module.exports = __webpack_public_path__ + "static/website-development-106d1965785029d940a4f3e85780565d.png";